import React from 'react';
import PropTypes from 'prop-types';
import { Svg } from '@jg/components';
import Steps from 'components/Steps/Steps';
import matchmymiles from 'assets/svg/matchmymiles-red.svg';

import './Header.scss';

const Header = ({ step }) => (
  <div className="header">
    <Svg markup={matchmymiles} alt="MATCHmyMILES" className="header__matchmymiles-logo" />
    { step && (
      <Steps step={step} />
    )}
  </div>
);

Header.propTypes = {
  step: PropTypes.string,
};

Header.defaultProps = {
  step: '',
};

export default Header;



// WEBPACK FOOTER //
// ./components/Header/Header.js